import TasteimonialStatusOption from 'constants/tasteimonial-status-option';
import TasteimonialsService from 'services/tasteimonialsService';

const tableOptions = {
  tasteimonials: {
    fields: [
      {
        id: 'note',
        label: 'table.tasteimonials.note',
        type: 'text',
        sortable: true,
        width: '16%',
      },
      {
        id: 'noteResponse',
        label: 'table.tasteimonials.response',
        type: 'text',
        sortable: false,
        width: '16%',
      },
      {
        id: 'partnerName',
        label: 'table.tasteimonials.partnerName',
        orderField: 'include_serviceProviders_name',
        type: 'text',
        sortable: true,
        width: '9%',
      },
      {
        id: 'producer',
        label: 'table.tasteimonials.producer',
        orderField: 'include_menuItems_producer',
        type: 'text',
        sortable: true,
        width: '9%',
      },
      {
        id: 'wine',
        label: 'table.tasteimonials.wine',
        orderField: 'include_menuItems_name',
        type: 'text',
        sortable: true,
        width: '9%',
      },
      {
        id: 'vintage',
        label: 'table.tasteimonials.vintage',
        orderField: 'include_menuItems_year',
        type: 'text',
        sortable: true,
        width: '5%',
      },
      {
        id: 'wineList',
        label: 'table.tasteimonials.wineList',
        orderField: 'include_menus_menuName',
        type: 'text',
        sortable: true,
        width: '9%',
      },
      {
        id: 'wineLoverName',
        label: 'table.tasteimonials.wineLover',
        type: 'link',
        route: '/wineLovers/:id',
        routeIdKey: 'wineLoverId',
        sortable: false,
        width: '9%',
      },
      {
        id: 'status',
        label: 'table.tasteimonials.status',
        type: 'text',
        sortable: true,
        width: '5%',
      },
      {
        id: 'createdAt',
        label: 'table.tasteimonials.createdAt',
        type: 'date',
        sortable: true,
        minWidth: '120px',
        textAlign: 'right',
        headAlign: 'right',
        width: '13%',
      },
    ],
    rowsPerPageOptions: [5, 10, 25, 50, 100],
    filterFields: [
      {
        id: 'createdAt',
        label: 'table.tasteimonials.filter.createdAt',
        type: 'dateRange',
        priority: 1,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'wineLoverName_in',
        label: 'table.tasteimonials.filter.wineLoverName',
        type: 'custom-multi-autocomplete',
        options: TasteimonialsService.getWineLoverNames,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
      },
      {
        id: 'serviceProviderId_in',
        label: 'table.tasteimonials.filter.partnerName',
        type: 'custom-multi-autocomplete',
        options: TasteimonialsService.getSPListNames,
        withoutParams: true,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
      },
      {
        id: 'include_menuItems_producer_in',
        label: 'table.tasteimonials.filter.producerName',
        type: 'custom-multi-autocomplete',
        options: TasteimonialsService.getProducersNames,
        optionsType: 'string',
        withoutParams: false,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'menuItemId_in',
        label: 'table.tasteimonials.filter.wineName',
        type: 'custom-multi-autocomplete',
        options: TasteimonialsService.getWinesNames,
        withoutParams: false,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'menuId_in',
        label: 'table.tasteimonials.filter.wineListName',
        type: 'custom-multi-autocomplete',
        options: TasteimonialsService.getMenusNames,
        withoutParams: false,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'status',
        label: 'table.tasteimonials.filter.status.title',
        type: 'select',
        options: TasteimonialStatusOption,
        priority: 1,
        selectedClassName: 'colorizeSelected',
      },
    ],
    searchFields: ['note'],
  },
};

export default tableOptions;
